(function () {
  'use strict';

  function parseMoney(text) {
    var normalized = (text || '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var value = Number.parseFloat(normalized);
    return Number.isFinite(value) ? value : 0;
  }

  function updateProductPrice() {
    document.querySelectorAll('[data-testid="product-information"] product-price').forEach(function (price) {
      var container = price.querySelector('[ref="priceContainer"]');
      if (!container) return;

      var sale = container.querySelector('.price-item__group.price');
      var compare = container.querySelector('.compare-at-price');
      var existingBadge = container.querySelector('.ll-save-badge');

      if (!sale || !compare) {
        if (existingBadge) existingBadge.remove();
        return;
      }

      var saleValue = parseMoney(sale.textContent);
      var compareValue = parseMoney(compare.textContent);
      if (!saleValue || compareValue <= saleValue) {
        if (existingBadge) existingBadge.remove();
        return;
      }

      var savings = Math.round(compareValue - saleValue);
      if (!existingBadge) {
        existingBadge = document.createElement('span');
        existingBadge.className = 'll-save-badge';
        container.appendChild(existingBadge);
      }
      existingBadge.textContent = 'SAVE $' + savings;
    });
  }

  function observePrices() {
    document.querySelectorAll('[data-testid="product-information"] product-price').forEach(function (price) {
      if (price.dataset.llObserved === 'true') return;
      price.dataset.llObserved = 'true';

      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          updateProductPrice();
        });
      }).observe(price, { childList: true, subtree: true, characterData: true });
    });
  }

  function getActiveMediaRatio(gallery) {
    var activeSlide =
      gallery.querySelector('slideshow-slide.product-media-container[aria-hidden="false"]') ||
      gallery.querySelector('slideshow-slide.product-media-container');

    if (!activeSlide) return 0;

    var media = activeSlide.querySelector('.product-media');
    var ratio = media ? Number.parseFloat(media.style.getPropertyValue('--ratio')) : 0;

    if (!ratio) {
      ratio = Number.parseFloat(activeSlide.style.getPropertyValue('--media-preview-ratio'));
    }

    return Number.isFinite(ratio) && ratio > 0 ? ratio : 0;
  }

  function syncProductGalleryRatio(gallery) {
    var ratio = getActiveMediaRatio(gallery);
    if (!ratio) return;

    gallery.style.setProperty('--ll-active-media-ratio', ratio);
  }

  function observeProductGalleries() {
    document
      .querySelectorAll('[data-testid="product-information"] media-gallery.media-gallery--carousel')
      .forEach(function (gallery) {
        syncProductGalleryRatio(gallery);

        if (gallery.dataset.llRatioObserved === 'true') return;
        gallery.dataset.llRatioObserved = 'true';

        new MutationObserver(function (mutations) {
          var activeSlideChanged = mutations.some(function (mutation) {
            return mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden';
          });

          if (activeSlideChanged) {
            window.requestAnimationFrame(function () {
              syncProductGalleryRatio(gallery);
            });
          }
        }).observe(gallery, {
          attributes: true,
          attributeFilter: ['aria-hidden'],
          subtree: true,
        });
      });
  }

  var galleryInitScheduled = false;

  function scheduleProductGalleryInit() {
    if (galleryInitScheduled) return;
    galleryInitScheduled = true;

    window.requestAnimationFrame(function () {
      galleryInitScheduled = false;
      observeProductGalleries();
    });
  }

  function init() {
    updateProductPrice();
    observePrices();
    observeProductGalleries();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:update', updateProductPrice);
  document.addEventListener('variant:update', scheduleProductGalleryInit);

  new MutationObserver(scheduleProductGalleryInit).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
